import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../../shared/core2Config';
import {WfIssueEventContainerModel} from "../../../../../../models";

@Injectable({providedIn: 'root'})
export class WfIssueEventService extends BaseApiTemplateService<WfIssueEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_MICRO_SERVICES_CRM_URL_PREFIX + 'issue-events';
    this.endpoint_path = Core2Config.TENANT_MICRO_SERVICES_CRM_URL_PREFIX + 'issue-events';
    this.httpClient = http;
  }
}
